import {Amplify} from 'aws-amplify';

import {stage} from '../config/stage';

// get config
import {config} from '../config/amplify';
import {ConsoleLogger} from 'aws-amplify/utils';

Amplify.configure(config);

ConsoleLogger.LOG_LEVEL = stage === 'ide' ? 'DEBUG' : 'INFO';

declare let window: any;

window.LOG_LEVEL = 'DEBUG';
